module.exports = __webpack_public_path__ + "img/Dantam Makeover 26.27caf2a1.jpg";